import type { PrimarySearchFilters } from '../const'

export default function createFacetFiltersFromSlug(
  slug: string,
): PrimarySearchFilters {
  const result: Partial<PrimarySearchFilters> = {}

  if (!slug) {
    return result
  }

  // Special case for paid - check if the slug contains -paid
  if (/paid(?:$|\/|-)/i.test(slug)) {
    result.paid = 'true'
  }

  const patterns: Record<keyof Omit<PrimarySearchFilters, 'paid'>, RegExp> = {
    city: /near-([^-].*?)(?=-(?:using|at|for|within|paid)\b|$|\/)/i,
    condition: /for-([^-].*?)(?=-(?:near|using|at|within|paid)\b|$)/i,
    hospital: /at-([^-].*?)(?=-(?:for|near|using|within|paid)\b|$)/i,
    state: /within-([^-].*?)(?=-(?:near|using|at|for|paid)\b|$|\/)/i,
    treatment: /using-([^-].*?)(?=-(?:near|at|for|within|paid)\b|$|\/)/i,
  }

  // Try to match each pattern
  Object.entries(patterns).forEach(([key, pattern]) => {
    const match = slug.match(pattern)
    if (match && match[1]) {
      result[key as keyof PrimarySearchFilters] = decodeURIComponent(
        match[1].trim().toLowerCase(),
      )
    }
  })

  return result
}
